/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";

function HeadPhone({ name, src, imageurl }) {
  const audio = new Audio(src);

  React.useEffect(() => {
    return () => {
      audio.pause();
    };
  }, [audio]);

  return (
    <div
      className="headphone"
      style={{
        display: "inline-block",
        cursor: "url(img/volume.png) 12 12, auto",
      }}
      onClick={() => {
        audio.play();
      }}
    >
      <img
        src={imageurl ? imageurl : "img/1.jpg"}
        alt=""
        style={{
         
          height: "15mm",
          marginLeft: -10,
          marginRight: 16,
          marginTop: 2,
          // cursor: 'url(img/volume.png) 12 12, auto',
        }}
        // onClick={() => {
        //   audio.play();
        // }}
      />
     
    </div>
  );
}

export default HeadPhone;
